import MainLayout from './features/layouts/mainLayout';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, ToastContainer } from 'react-toastify';
import ScrollToTop from './features/scrollToTop';
import { useAddDispatch } from './store';
import { loadUserFromStorage } from './auth/userSlice';
import { useEffect } from 'react';
import { PageTracker } from './features/pageTracker';

function App() {
  const dispatch = useAddDispatch();

  useEffect(() => {
    dispatch(loadUserFromStorage());
  }, [dispatch]);

  return (
    <>
      <PageTracker />
      <ScrollToTop />
      <MainLayout />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </>
  );
}

export default App;
